import { ReactElement } from "react";
import CCOBadge from "./CCOBadge";
import CRBadge from "./CRBadge";
import { PtUserRole } from "../../store/apis/enhancedApi";

interface Props {
  role: PtUserRole;
  className?: string;
}

const PTUserRoleBadge = (props: Props): ReactElement => {
  const { role, className } = props;

  switch (role.name) {
    case "CCO":
      return <CCOBadge className={className} />;
    case "TCSSO":
      return <CRBadge className={className} />;
    default:
      return <></>;
  }
};

export default PTUserRoleBadge;
